import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { GridNavService } from './grid.nav.service';

@Component({
    selector: 'mlp-ng-grid-nav',
    templateUrl: './grid.nav.component.html',
    styleUrls: ['./grid.nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class GridNavSharedComponent implements OnInit {
    @Input() layout: string;

    constructor(public gridNavService: GridNavService) {}

    ngOnInit(): void {
        // tslint:disable-next-line:max-line-length
        this.gridNavService.formation = (this.gridNavService.formation) ? this.gridNavService.formation : (this.layout) ? this.layout : 'grid';
    }
}
